import { useEffect } from 'react';
import { IS_PROD } from '../config/api';
import { useLocale } from '../i18n/LocaleContext';
import { useAuth } from '../auth/AuthContext';
import './DevBanner.scss';

// Thin banner pinned to the top of every page on a local or dev build, and for
// any logged-in dev user on the live portal (documents#654), so nobody mistakes
// it for live.
// Mirrors the admin panel's banner; see admin/src/components/DevBanner.js.
export default function DevBanner() {
  const { t } = useLocale();
  const { user } = useAuth();
  const devUser = user?.environment === 'dev';
  const isDev = !IS_PROD || devUser;

  // Push page content down by the banner height so it never covers the header.
  useEffect(() => {
    if (!isDev) return undefined;
    document.body.classList.add('has-dev-banner');
    return () => document.body.classList.remove('has-dev-banner');
  }, [isDev]);

  if (!isDev) return null;

  if (devUser) {
    return (
      <div className="dev-banner">
        <span className="dev-banner-full">{t('dev.userBannerFull')}</span>
        <span className="dev-banner-short">{t('dev.userBannerShort')}</span>
      </div>
    );
  }

  return (
    <div className="dev-banner">
      <span className="dev-banner-full">{t('dev.bannerFull')}</span>
      <span className="dev-banner-short">{t('dev.bannerShort')}</span>
      {/* _top so the link escapes the Shopify admin iframe the partner
          portal also runs inside; on a normal page it is just this window. */}
      <a href="https://partners.outfino.app" target="_top" rel="noopener">partners.outfino.app</a>
    </div>
  );
}
